import React from 'react'
import InputElement from 'components/FormElements/InputElement'
import ReactHtmlParser from 'react-html-parser';
import {
   handleInputChange
} from 'utils/FormHandler'
import {
   Grid
} from 'semantic-ui-react'
import Config from 'Config'
import axios from 'axios'

class Contact extends React.Component {

   constructor() {
      super()
      this.state = {
         data: {},
         fields: {
            name: '',
            company: '',
            phone: '',
            email: '',
            message: '',
            privacy: false,
         },
         touched: {},
         errors: {},
         contactSubmitted: false,
         contactError: false,
      }
   }

   handleInputChange(e) {
      const fields = handleInputChange(this.state.fields, e)
      if (fields) {
         this.setState({
            fields: fields
         });
         this.handleBlur(e);
         this.validateForm();
      }
   }

   handleBlur(e) {
      const target = e.target;
      let touched = this.state.touched;
      touched[target.name] = true;

      this.setState({
         touched
      });
      this.validateForm();
   }

   handleSubmit(event) {
      event.preventDefault();

      if (this.validateForm(true)) {
         this.submitForm(this.state.fields);
      }
   }

   validateForm(submitAfterValidation = false) {

      var validator = require("email-validator");

      let formIsValid = true;
      let fields = this.state.fields;
      let touched = this.state.touched;
      let errors = {};

      if (!fields['name']) {
         formIsValid = false;

         if (submitAfterValidation || touched['name']) {
            errors['name'] = true;
         }
      }

      ;
      if (!fields['email'] || !validator.validate(fields['email'])) {
         formIsValid = false;

         if (submitAfterValidation || touched['email']) {
            errors['email'] = true;
         }
      }

      if (!fields['message']) {
         formIsValid = false;

         if (submitAfterValidation || touched['message']) {
            errors['message'] = true;
         }
      }

      if (!fields['privacy']) {
         formIsValid = false;

         if (submitAfterValidation || touched['privacy']) {
            errors['privacy'] = true;
         }
      }

      this.setState({
         errors: errors
      });
      return formIsValid;
   }

   submitForm(data) {

      axios.post(Config().endpoints.api + '/contact', data)
         .then(response => {
            this.setState({
               contactSubmitted: true
            });
         })
         .catch((error) => {
            this.setState({
               contactError: true
            });
         })
   }

   componentDidMount() {
      this.getData();
   }

   getData() {

      axios.get(Config().endpoints.api + "/contact")
         .then(response => {
            if (response.data) {
               this.setState({
                  data: response.data[0]
               });
            }
         })
         .catch((error) => {})
   }

   render() {


      const contactForm = (
         <form onSubmit={this.handleSubmit.bind(this)}>
            <div className="ui divider section hidden"></div>
            <div className="ui divider section hidden"></div>
               <Grid>
                <Grid.Column mobile={16} computer={8}>
                  <InputElement
                  	title="Vorname, Name"
                  	name="name"
                  	inputType="text"
                  	value={this.state.fields.name}
                  	isRequired={true}
                  	errorMsg="Bitte geben Sie Ihren Namen ein."
                  	hasError={this.state.errors}
                  	onBlur={this.handleBlur.bind(this)}
                  	onChange={this.handleInputChange.bind(this)}
                  />
                  <InputElement
                     title="Firma"
                     name="company"
                     inputType="text"
                     value={this.state.fields.company}
                     onBlur={this.handleBlur.bind(this)}
                     onChange={this.handleInputChange.bind(this)}
                  />
                  <InputElement
                     title="Telefon"
                     name="phone"
                     inputType="text"
                     value={this.state.fields.phone}
                     onBlur={this.handleBlur.bind(this)}
                     onChange={this.handleInputChange.bind(this)}
                  />
                  <InputElement
                     title="E-Mail"
                     name="email"
                     inputType="text"
                     value={this.state.fields.email}
                     isRequired={true}
                     errorMsg="Bitte geben Sie Ihre E-Mail Adresse ein."
                     hasError={this.state.errors}
                     onBlur={this.handleBlur.bind(this)}
                     onChange={this.handleInputChange.bind(this)}
                  />
                </Grid.Column>
                <Grid.Column mobile={16} computer={8}>
                  <InputElement
                  	title="Nachricht"
                  	name="message"
                  	inputType="textarea"
                     className="very-large-input"
                  	value={this.state.fields.message}
                  	isRequired={true}
                  	errorMsg="Bitte geben Sie eine Nachricht ein."
                  	hasError={this.state.errors}
                  	onBlur={this.handleBlur.bind(this)}
                  	onChange={this.handleInputChange.bind(this)}
                  />
                </Grid.Column>
               </Grid>
              <InputElement
                 title="Hiermit erkläre ich, dass ich die Datenschutzbedingungen gelesen habe und diese akzeptiere."
                 name="privacy"
                 inputType="checkbox"
                 isRequired={true}
                 errorMsg="Bitte bestätigen Sie unsere Datenschutzbedingungen."
                 hasError={this.state.errors}
                 onBlur={this.handleBlur.bind(this)}
                 onChange={this.handleInputChange.bind(this)}
              />
            <div className="button filled" onClick={this.handleSubmit.bind(this)}>Anfrage Senden</div>
         </form>
      );

      const contactNotification = (
         <div className="centered bold">Ihre Kontaktanfrage wurde erfolgreich gesendet.</div>
      );

      const contactNotificationError = (
         <div className="centered bold">Beim versenden Ihrer Kontakanfrage ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch ein mal.</div>
      );

      return (<div>
         <div className="content-container">
            <div className="content-section">
               <h1 className="centered section-bottom-medium">{this.state.data.title}</h1>
               <div className="centered">{ ReactHtmlParser(this.state.data.content) }</div>
               {(this.state.contactError ? contactNotificationError : '')}
               {(this.state.contactSubmitted ? contactNotification : contactForm)}
         </div>
         </div>
      </div>);
   }
}

export default Contact



// WEBPACK FOOTER //
// ./src/components/Contact/index.js